import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "task_group";

moduleApi.create = async (dataForm) => { 
  let api = {
     module: moduleName,
     type: "create",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 };
 
 moduleApi.update = async (dataForm) => {
   let api = {
     module: moduleName,
     type: "partialUpdate",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 }; 

 
moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id},
    message: {
        success: "", //string | null | comment
        error: "hidden", //string | null | comment
    },
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
